import React, { Component } from 'react';

export default class TestComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
    console.log("Constructor TestComponent", this.props);
  }

  render() {
    return (
      <div>
      Flux Test
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/TestComponent.js